import { RcClasses } from '../../../foundation';
var RcChipClasses = RcClasses(['avatar', 'disabled', 'deleteIcon', 'focused'], 'RcChip');
export { RcChipClasses };
